import React, {useEffect} from "react";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import PBLogo from "../../assets/images/pb-logo.png";
import Version from "../common/version";
import LanguagePicker from "../common/LanguagePicker";

const Header = (userData) => {
  const { t } = useTranslation();

  useEffect(() => {
    // console.log(userData);
  }, []);
  return (
    <header>
      <Container
        className="text-end d-flex align-items-center justify-content-between"
        fluid
      >
        <Version />
        {userData ? userData.userData ? userData.userData.agencyInfo ? (<h3>{t("header.applicationTitle", { agency: userData.userData.agencyInfo.name })}</h3>) : <h3 /> : <h3 /> : <h3 /> }
        <div className="d-flex align-items-center gap-2">
          <LanguagePicker />
          <img src={PBLogo} height="25px" alt="SembraLogo" />
        </div>
      </Container>
    </header>
  );
}

export default Header
